import { domain } from "../../domain";

export {
    outOfStock
}

function outOfStock(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/get-outOfStock?id=${id}`;
    } else if(name){
        return `${domain}/pos/get-outOfStock?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/get-outOfStock?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}